import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  APP_PATH,
  DEFAULT_BLUE,
  DEFAULT_BUTTON_STYLE,
  DEFAULT_GOLD,
  DEFAULT_RED,
} from "../../constant";
import CountryAutocomplete from "../../GeneralComponents/CountryAutocomplete/CountryAutocomplete";
import { constructGoogleFormUrl } from "./helpers";
import { Link } from "react-router-dom";
import Header from "../../GeneralComponents/Header/Header";

const validationSchema = Yup.object({
  name: Yup.string().required("Le nom de famille est requis"),
  firstname: Yup.string().required("Le prénom est requis"),
  for: Yup.string().required("Champs est requis"),
  birthdate: Yup.string().required("La date de naissance est requise"),
  country: Yup.string().required("Le pays est requis"),
  phone: Yup.string().required("Le numéro de téléphone est requis"),
  email: Yup.string().email("Email invalide").required("L'email est requis"),
  program: Yup.string().required("Le programme est requis"),
  // level: Yup.string().required("Le niveau est requis"),
  frequency: Yup.string().required("La fréquence est requise"),
  days: Yup.string().required("Les jours sont requis"),
  // alone: Yup.string().required("La réponse est requise"),
  // additionalPhone: Yup.string().required(
  //   "Le numéro de téléphone supplémentaire est requis"
  // ),
  // alreadyLearnArabic: Yup.string().required("Le consentement est requis"),
  // learningInfo: Yup.string().required("La compétence est requise"),
  confirmation: Yup.bool().oneOf([true], "Vous devez accepter les conditions"),
});

const SubscribeForm: React.FC = () => {
  const [formValues] = useState({
    name: "",
    firstname: "",
    for: "",
    birthdate: "",
    country: "",
    phone: "",
    email: "",
    program: "",
    level: "",
    frequency: "",
    days: "",
    alone: "",
    additionalPhone: "",
    alreadyLearnArabic: "",
    learningInfo: "",
    confirmation: false,
  });
  const [age, setAge] = useState<string>("");

  const calculateAge = (birthdate: string) => {
    const birthDate = new Date(birthdate);
    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return { years, months, days };
  };

  const handleBirthdateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const ageDetails = calculateAge(value);

    console.log(ageDetails);
    setAge(
      `Vous avez ${ageDetails.years} ans ${ageDetails.months} mois et ${ageDetails.days} jours`
    );
  };

  const today = new Date().toISOString().split("T")[0];
  const handleSubmit = (values: any, { resetForm }: any) => {
    console.log(values);
    const googleFormUrl = constructGoogleFormUrl(values);

    window.open(googleFormUrl, "_blank");
    resetForm();
  };

  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Header title="S'inscrire à l'Institut" subtitle="Al-Ansarr" />
      <Box
        sx={{
          my: 4,
          border: "1px solid #f0f0f0",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
          padding: "20px",
          borderRadius: "10px",
          maxWidth: "500px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="body1" align="justify" gutterBottom>
          Veuillez remplir le formulaire ci-dessous pour vous inscrire à
          l'Institut Al-Ansarr. Nous vous contacterons dans les plus brefs
          délais.
        </Typography>
        <Formik
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, handleBlur, isSubmitting, errors }) => (
            <div>
              <Form>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    label="Nom de famille *"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    error={Boolean(errors.name)}
                    helperText={
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error-message"
                      />
                    }
                  />
                </FormControl>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    label="Prénom *"
                    name="firstname"
                    value={values.firstname}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    error={Boolean(errors.firstname)}
                    helperText={
                      <ErrorMessage
                        name="firstname"
                        component="div"
                        className="error-message"
                      />
                    }
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{
                    marginBottom: "10px",
                  }}
                >
                  <FormLabel
                    component="legend"
                    sx={{
                      paddingLeft: "15px",
                      color: errors.for && DEFAULT_RED,
                    }}
                  >
                    Pour *
                  </FormLabel>
                  <RadioGroup
                    name="for"
                    value={values.for}
                    onChange={handleChange}
                    sx={{
                      paddingLeft: "15px",
                    }}
                    row
                  >
                    <FormControlLabel
                      value="Homme"
                      control={<Radio />}
                      label="Homme"
                    />
                    <FormControlLabel
                      value="Femme"
                      control={<Radio />}
                      label="Femme"
                    />
                    <FormControlLabel
                      value="Enfant"
                      control={<Radio />}
                      label="Enfant"
                    />
                  </RadioGroup>
                  <FormHelperText>
                    <ErrorMessage
                      name="for"
                      component="div"
                      className="error-message"
                    />
                  </FormHelperText>
                </FormControl>
                <br />
                <FormControl fullWidth variant="outlined">
                  <FormLabel
                    component="legend"
                    htmlFor="birthdate"
                    sx={{
                      paddingLeft: "15px",
                      color: errors.birthdate && DEFAULT_RED,
                    }}
                  >
                    Date de naissance *
                  </FormLabel>
                  <TextField
                    name="birthdate"
                    type="date"
                    id="birthdate"
                    value={values.birthdate}
                    onChange={(e) => {
                      handleChange(e);
                      handleBirthdateChange(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    margin="normal"
                    inputProps={{ max: today }}
                    sx={{ marginTop: "0" }}
                    error={Boolean(errors.birthdate)}
                    helperText={
                      <ErrorMessage
                        name="birthdate"
                        component="div"
                        className="error-message"
                      />
                    }
                  />
                  {age.length > 0 && (
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        margin: "0 0 0 15px",
                        position: "relative",
                        top: "-13px",
                        color: "rgba(0, 0, 0, 0.6)",
                      }}
                    >
                      {age}
                    </Typography>
                  )}
                </FormControl>

                <CountryAutocomplete
                  value={values.country}
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: "country",
                        value: newValue ? newValue.label : "",
                      },
                    });
                  }}
                  error={Boolean(errors.country)}
                  helperText={errors.country ? errors.country : ""}
                />
                <FormControl fullWidth variant="outlined">
                  <TextField
                    label="Numéro de téléphone *"
                    name="phone"
                    type="tel"
                    error={Boolean(errors.phone)}
                    value={values.phone}
                    onChange={handleChange}
                    fullWidth
                    // margin="normal"
                    sx={{ marginTop: "10px" }}
                    helperText={
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error-message"
                      />
                    }
                  />
                </FormControl>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    label="Email *"
                    name="email"
                    type="email"
                    error={Boolean(errors.email)}
                    value={values.email}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    helperText={
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error-message"
                      />
                    }
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  variant="outlined"
                  error={Boolean(errors.program)}
                >
                  <InputLabel id="program-label">Programme *</InputLabel>
                  <Select
                    labelId="program-label"
                    name="program"
                    value={values.program}
                    onChange={handleChange}
                    label="Quel programme souhaitez-vous suivre ?"
                  >
                    <MenuItem value="Programme de L'Institut Al-Ansarr">
                      Programme de L'Institut Al-Ansarr
                    </MenuItem>
                    <MenuItem value="Autre programme">Autre programme</MenuItem>
                  </Select>
                  <FormHelperText>
                    <ErrorMessage
                      name="program"
                      component="div"
                      className="error-message"
                    />
                  </FormHelperText>
                  {values.program === "Autre programme" && (
                    <TextField
                      label="Détaillez nous le programme que vous souhaitez suivre"
                      name="level"
                      value={values.level}
                      onChange={handleChange}
                      fullWidth
                      margin="normal"
                      helperText={
                        <ErrorMessage
                          name="level"
                          component="div"
                          className="error-message"
                        />
                      }
                    />
                  )}
                </FormControl>
                <div style={{ height: "10px" }} />

                <FormControl
                  fullWidth
                  variant="outlined"
                  error={Boolean(errors.frequency)}
                >
                  <InputLabel id="frequency-label">
                    Combien d'heure je souhaite étudier par semaine ? *
                  </InputLabel>
                  <Select
                    labelId="frequency-label"
                    name="frequency"
                    value={values.frequency}
                    onChange={handleChange}
                    label="Combien d'heure je souhaite étudier par semaine ?"
                  >
                    <MenuItem value="3h/semaine">3h/semaine</MenuItem>
                    <MenuItem value="4h/semaine">4h/semaine</MenuItem>
                    <MenuItem value="5h/semaine">5h/semaine</MenuItem>
                    <MenuItem value="6h/semaine">6h/semaine</MenuItem>
                    <MenuItem value="7h/semaine">7h/semaine</MenuItem>
                    <MenuItem value="8h/semaine">8h/semaine</MenuItem>
                    <MenuItem value="9h/semaine">9h/semaine</MenuItem>
                    <MenuItem value="10h/semaine">10h/semaine</MenuItem>
                  </Select>
                  <FormHelperText>
                    <ErrorMessage
                      name="frequency"
                      component="div"
                      className="error-message"
                    />
                  </FormHelperText>
                </FormControl>

                <FormControl fullWidth variant="outlined">
                  <TextField
                    label="Vos disponibilités (Jours/Heures) *"
                    name="days"
                    value={values.days}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    margin="normal"
                    error={Boolean(errors.days)}
                    helperText={
                      <ErrorMessage
                        name="days"
                        component="div"
                        className="error-message"
                      />
                    }
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  variant="outlined"
                  error={Boolean(errors.alone)}
                >
                  <FormLabel component="legend">Seul ou en Binôme ?</FormLabel>
                  <RadioGroup
                    name="alone"
                    value={values.alone}
                    onChange={handleChange}
                    sx={{
                      paddingLeft: "15px",
                    }}
                    row
                  >
                    <FormControlLabel
                      value="Seul"
                      control={<Radio />}
                      label="Seul"
                    />
                    <FormControlLabel
                      value="Binôme"
                      control={<Radio />}
                      label="En binôme"
                    />
                  </RadioGroup>
                  <FormHelperText>
                    <ErrorMessage
                      name="alone"
                      component="div"
                      className="error-message"
                    />
                  </FormHelperText>
                </FormControl>

                {values.alone === "Binôme" && (
                  <FormControl fullWidth variant="outlined">
                    <TextField
                      label="Numéro de votre binôme"
                      type="tel"
                      name="additionalPhone"
                      value={values.additionalPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      margin="normal"
                      error={Boolean(errors.additionalPhone)}
                      helperText={
                        <ErrorMessage
                          name="additionalPhone"
                          component="div"
                          className="error-message"
                        />
                      }
                    />
                  </FormControl>
                )}
                <br />
                <FormControl fullWidth variant="outlined">
                  <FormLabel component="legend">
                    Avez-vous déjà étudié la langue arabe ?
                  </FormLabel>
                  <RadioGroup
                    name="alreadyLearnArabic"
                    value={values.alreadyLearnArabic}
                    onChange={handleChange}
                    sx={{
                      paddingLeft: "15px",
                    }}
                    row
                  >
                    <FormControlLabel
                      value="Oui"
                      control={<Radio />}
                      label="Oui"
                    />
                    <FormControlLabel
                      value="Non"
                      control={<Radio />}
                      label="Non"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.alreadyLearnArabic}</FormHelperText>
                </FormControl>
                {values.alreadyLearnArabic === "Oui" && (
                  <FormControl fullWidth variant="outlined">
                    <TextField
                      label="Pouvez-vous nous faire part de votre parcours d'étude ?"
                      name="learningInfo"
                      value={values.learningInfo}
                      onChange={handleChange}
                      fullWidth
                      margin="normal"
                      helperText={
                        <ErrorMessage
                          name="learningInfo"
                          component="div"
                          className="error-message"
                        />
                      }
                    />
                  </FormControl>
                )}

                <br />
                <FormControl
                  fullWidth
                  variant="outlined"
                  error={Boolean(errors.confirmation)}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="confirmation"
                        checked={values.confirmation}
                        onChange={handleChange}
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        color={errors.confirmation && "error"}
                      >
                        J'accepte les conditions du règlement intérieur de
                        l'Institut Al-Ansarr (
                        <Link to={APP_PATH.RULES}>voir ici</Link>)
                      </Typography>
                    }
                  />
                  {errors.confirmation && (
                    <FormHelperText error>{errors.confirmation}</FormHelperText>
                  )}
                </FormControl>

                <Divider sx={{ my: 2 }} />
                {Object.keys(errors).length > 0 && (
                  <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                    Veuillez remplir tous les champs obligatoires.
                  </Typography>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  sx={{
                    width: "100%",
                    backgroundColor: DEFAULT_BLUE,
                    color: DEFAULT_GOLD,
                    ...DEFAULT_BUTTON_STYLE,
                  }}
                >
                  {isSubmitting ? "Envoie..." : "Envoyer"}
                </Button>
              </Form>
            </div>
          )}
        </Formik>
      </Box>
    </Container>
  );
};

export default SubscribeForm;
